import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export default function CTASection() {
  return (
    <section className="relative py-16 sm:py-20 bg-gradient-to-br from-brand-dark via-brand-primary to-brand-dark text-white overflow-hidden" data-testid="cta-section">
      <div className="absolute -top-32 -right-32 w-[420px] h-[420px] rounded-full bg-brand-gold/20 blur-3xl pointer-events-none" />
      <div className="absolute -bottom-40 -left-32 w-[420px] h-[420px] rounded-full bg-brand-gold/10 blur-3xl pointer-events-none" />

      <div className="relative max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        >
          <span className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.3em] font-semibold text-brand-gold">
            <span className="w-8 h-px bg-brand-gold" /> Ready to Begin?
          </span>
          <h2 className="display-serif mt-4 text-3xl sm:text-4xl lg:text-5xl font-extrabold leading-[1.05]">
            Start Your Learning <span className="italic text-brand-gold">Journey</span> Today
          </h2>
          <p className="mt-4 text-white/85 max-w-2xl mx-auto leading-relaxed">
            Join AM Group of Education and achieve your academic and career goals with India&apos;s trusted mentors.
          </p>
          <div className="mt-8 flex flex-wrap gap-3 justify-center">
            <Link to="/contact" className="btn-primary !bg-brand-gold !text-brand-dark hover:!bg-white" data-testid="cta-enroll-btn">
              Enroll Now <i className="fa-solid fa-arrow-right" />
            </Link>
            <Link to="/contact" className="btn-outline !border-brand-gold !text-brand-gold hover:!bg-brand-gold hover:!text-brand-dark" data-testid="cta-counselor-btn">
              Talk to Counselor <i className="fa-solid fa-headset" />
            </Link>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
